import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Fade,
  IconButton,
  Typography,
} from '@material-ui/core';
import './index.scss';
import CloseIconModal from 'assets/icons/CloseIconModal';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import CustomUploadSingle from 'components/CustomUploadSingle';
import CustomSelect from 'components/CustomSelect';
import {
  CONTRATO_FLUXO_DESCENTRALIZADO,
  CONTRATO_MODAL_DE_ARQUIVOS,
  TipoContrato,
  URL_ENTE_DESCENTRALIZADO,
  VersaoContratoDescricao,
  VersaoContratoEnum,
} from 'models/contratos';
import {
  loadContratoAssessor,
} from 'store/modules/ContratosFluxoDescentralizado/Assessores/AssessoresActions';
import {
  contratoUploadDocAssinado,
  contratoUploadDocPlanoTrabalho,
  contratoUploadDocPlanoTrabalhoEDocAssinado,
  contratoUploadExtrato,
  loadContratoAdendos,
  addSelectedOption,
  clearUploadedFile,
  clearUploadSelectedOption,
} from 'store/modules/AllContratos/AllContratosActions';
import SnackbarUtils from 'utils/SnackbarUtils';
import { AxiosError } from 'axios';
import {
  CreateRouteParams,
  EditRouteParams,
} from 'pages/Contratos/Fluxos/FluxoDescentralizados/__types';
import { useLocation, useParams } from 'react-router-dom';
import { Dispatch } from 'redux';
import { loadContratoEntePublico } from 'store/modules/ContratosFluxoDescentralizado/EntePublico/EntePublicoActions';
import { CallbackError, CallbackSuccess } from 'store/modules/AllContratos/__types';
import { loadContratoEntePrivado } from 'store/modules/ContratosFluxoDescentralizado/EntePrivado/EntePrivadoActions';
interface ModalProps {
  open: boolean;
  close: () => void;
  id: number | null;
  versaoContrato: number;
  idDocAssinado: number | null;
  idDocPlanoTrabalho: number | null;
  idDocExtrato: number | null;
  incluiPlanoTrabalho: boolean;
}

const ModalFiles = ({ close, open, id, versaoContrato, idDocAssinado, incluiPlanoTrabalho }: ModalProps) => {
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState<File | null>(null);
  const [selectedOptions, setSelectedOptions] = useState<number | null>(null);
  const uploadedFile = useSelector(
    (state: RootState) => state.allContratos.uploadSingleFile
  );
  const uploadSelectedOption = useSelector(
    (state: RootState) => state.allContratos.uploadSelectedOption
  );
  const languageValues = useSelector(
    (state: RootState) => state.languages.languageValues
  );
  const params = useParams<CreateRouteParams & EditRouteParams>();
  const location = useLocation();
  const dispatch = useDispatch();

  const fluxoAssessor = location.pathname.includes(URL_ENTE_DESCENTRALIZADO.ASSESSOR);
  const fluxoEntePublico = location.pathname.includes(URL_ENTE_DESCENTRALIZADO.ENTE_PUBLICO);
  const fluxoEntePrivado = location.pathname.includes(URL_ENTE_DESCENTRALIZADO.ENTE_PRIVADO);

  const getLabelContrato = (versaoContratoParam: number) => {
    switch (versaoContratoParam) {
      case VersaoContratoEnum.CONTRATO:
        return languageValues.contratoAssinado;
      case VersaoContratoEnum.ADITIVO:
        return languageValues.aditivoAssinado;
      case VersaoContratoEnum.DISTRATO:
        return languageValues.distratoAssinado;
      default:
        return languageValues.contratoAssinado;
    }
  };

  const getLabelContratoAssinadoEPlanoDeTrabalho = (versaoContratoParam: number) => {
    switch (versaoContratoParam) {
      case VersaoContratoEnum.CONTRATO:
        return languageValues.contratoAssinadoPlanoDeTrabalho;
      case VersaoContratoEnum.ADITIVO:
        return languageValues.aditivoAssinadoPlanoDeTrabalho;
      case VersaoContratoEnum.DISTRATO:
        return languageValues.distratoAssinadoPlanoDeTrabalho;
      default:
        return languageValues.contratoAssinadoPlanoDeTrabalho;
    }
  };

  const options = [
    { label: getLabelContrato(versaoContrato), value: CONTRATO_MODAL_DE_ARQUIVOS.CONTRATO_ASSINADO },
    { label: languageValues.contratoPlanoDeTrabalho, value: CONTRATO_MODAL_DE_ARQUIVOS.PLANO_DE_TRABALHO },
    { label: getLabelContratoAssinadoEPlanoDeTrabalho(versaoContrato), value: CONTRATO_MODAL_DE_ARQUIVOS.CONTRATO_ASSINADO_E_PLANO_DE_TRABALHO },
    { label: languageValues.contratoExtrato, value: CONTRATO_MODAL_DE_ARQUIVOS.EXTRATO },
  ];

  const filteredOptions = incluiPlanoTrabalho
    ? options.filter(option => option.value !== CONTRATO_MODAL_DE_ARQUIVOS.CONTRATO_ASSINADO && option.value !== CONTRATO_MODAL_DE_ARQUIVOS.PLANO_DE_TRABALHO)
    : options;

  const finalFilteredOptions = filteredOptions.filter(option => {
    if (option.value === CONTRATO_MODAL_DE_ARQUIVOS.EXTRATO) {
      return incluiPlanoTrabalho || idDocAssinado !== null;
    }
    return true;
  });

  const getTipoEnte = () => {
    const tipoMapping = {
      [CONTRATO_FLUXO_DESCENTRALIZADO.ASSESSOR]: TipoContrato.ASSESSOR,
      [CONTRATO_FLUXO_DESCENTRALIZADO.ENTE_PUBLICO]: TipoContrato.ENTE_PUBLICO,
      [CONTRATO_FLUXO_DESCENTRALIZADO.ENTE_PRIVADO]: TipoContrato.ENTE_PRIVADO,
    };
    return tipoMapping[params.tipoContrato] || 0;
  };

  const handleOptionsChange = (selectedValue: number | null) => {
    if (fluxoEntePublico) {
      if (selectedValue === null) {
        dispatch(clearUploadSelectedOption());
        setSelectedOptions(null);
      }
    }

    const tipoDeSelecaoContratoAssinado = () => {
      dispatch(addSelectedOption(CONTRATO_MODAL_DE_ARQUIVOS.CONTRATO_ASSINADO));
      setSelectedOptions(CONTRATO_MODAL_DE_ARQUIVOS.CONTRATO_ASSINADO);
    }

    switch (getTipoEnte()) {
      case TipoContrato.ASSESSOR:
      case TipoContrato.ENTE_PRIVADO:
        tipoDeSelecaoContratoAssinado();
        break;
      case TipoContrato.ENTE_PUBLICO:
        dispatch(addSelectedOption(selectedValue));
        setSelectedOptions(selectedValue);
        break;
      default:
        setSelectedOptions(null);
        break;
    }
  };

  const uploadFunctions: {
    [key: number]:
    (file: File, versaoContrato: string, id: number | null,
      callbackSuccess: CallbackSuccess,
      callbackError: CallbackError) =>
      (dispatch: Dispatch) => void
  } = {
    1: contratoUploadDocAssinado,
    2: contratoUploadDocPlanoTrabalho,
    3: contratoUploadDocPlanoTrabalhoEDocAssinado,
    4: contratoUploadExtrato
  };

  const handleClearFile = () => {
    dispatch(clearUploadedFile());
    setFile(null);
    handleClearFile()
  };

  const handleUpload = () => {
    if (uploadedFile && selectedOptions !== null) {
      setLoading(true);
      const versaoContratoName = getVersaoContratoName(versaoContrato);
      const idNumber = Number(id);
      const uploadFunction = selectedOptions !== null ? uploadFunctions[selectedOptions] : null;
      if (uploadFunction) {
        dispatch(
          uploadFunction(
            uploadedFile,
            versaoContratoName,
            idNumber,
            () => handleSuccess(versaoContrato),
            handleError
          )
        );
        if (fluxoEntePublico) {
          setSelectedOptions(null);
          dispatch(clearUploadSelectedOption())
          handleClearFile()
        }
        dispatch(clearUploadedFile())
        handleClearFile()
      } else {
        handleUnknownContractType();
      }
    } else {
      SnackbarUtils.enqueueSnackbar({
        message: languageValues.selecioneUmaOpcao,
        options: {
          variant: 'error',
        },
      });
    }
  };

  const getVersaoContratoName = (versaoContratoParam: VersaoContratoEnum): string => {
    switch (versaoContratoParam) {
      case VersaoContratoEnum.CONTRATO:
        return VersaoContratoDescricao.CONTRATO;
      case VersaoContratoEnum.ADITIVO:
        return VersaoContratoDescricao.ADITIVO;
      case VersaoContratoEnum.DISTRATO:
        return VersaoContratoDescricao.DISTRATO;
      default:
        return '';
    }
  };

  const handleSuccess = (versaoContratoSuccess: VersaoContratoEnum) => {
    setLoading(false);
    SnackbarUtils.enqueueSnackbar({
      message: languageValues.successUploadDocumento,
      options: {
        variant: 'success',
      },
    });

    const loadContratoAssessorData = () => {
      dispatch(loadContratoAdendos(Number(params.id)));
      dispatch(loadContratoAssessor(id, VersaoContratoEnum.CONTRATO));
    };

    const loadContratoEntePublicoData = () => {
      dispatch(loadContratoAdendos(Number(params.id)));
      dispatch(loadContratoEntePublico(id, VersaoContratoEnum.CONTRATO));
    };

    const loadContratoEntePrivadoData = () => {
      dispatch(loadContratoAdendos(Number(params.id)));
      dispatch(loadContratoEntePrivado(id, VersaoContratoEnum.CONTRATO));
    };

    switch (versaoContratoSuccess) {
      case VersaoContratoEnum.CONTRATO:
        if (fluxoAssessor) {
          loadContratoAssessorData();
        } else if (fluxoEntePublico) {
          loadContratoEntePublicoData();
        } else if (fluxoEntePrivado) {
          loadContratoEntePrivadoData()
        }
        break;
      case VersaoContratoEnum.ADITIVO:
      case VersaoContratoEnum.DISTRATO:
        if (fluxoAssessor || fluxoEntePublico || fluxoEntePrivado) {
          dispatch(loadContratoAdendos(Number(params.id)));
        }
        break;
      default:
        break;
    }
    close();
  };

  const handleError = (error: AxiosError) => {
    setLoading(false);
    const errorMessage =
      error?.response?.data?.message || languageValues.erroContratoUploadFile;
    SnackbarUtils.enqueueSnackbar({
      message: errorMessage,
      options: {
        variant: 'error',
      },
    });
  };

  const handleUnknownContractType = () => {
    setLoading(false);
    SnackbarUtils.enqueueSnackbar({
      message: languageValues.errotipoContratoDesconhecido,
      options: {
        variant: 'error',
      },
    });
  };

  const isSaveButtonDisabled = () => {
    return !uploadedFile || loading || uploadSelectedOption.length === 0;
  };

  const handleClose = () => {
    const shouldClose = !loading;
    const shouldResetOptionsEntePublico = !loading && fluxoEntePublico;
    const shouldResetOptionsAssessor = !loading && fluxoAssessor;
    const shouldResetOptionsEntePrivado = !loading && fluxoEntePrivado;
    if (shouldClose) {
      if (shouldResetOptionsEntePublico) {
        setSelectedOptions(null);
      } else if (shouldResetOptionsAssessor || shouldResetOptionsEntePrivado) {
        dispatch(clearUploadedFile())
      }
      close();
      setFile(null)
    }
  };

  useEffect(() => {
    if (fluxoAssessor || fluxoEntePrivado) {
      dispatch(addSelectedOption(CONTRATO_MODAL_DE_ARQUIVOS.CONTRATO_ASSINADO));
      setSelectedOptions(CONTRATO_MODAL_DE_ARQUIVOS.CONTRATO_ASSINADO);
    }
    // eslint-disable-next-line 
  }, [dispatch, params.tipoContrato]);

  return (
    <>
      <Dialog
        open={open}
        onClose={() => ""}
        aria-labelledby='form-dialog-files'
        className='form-dialog-files'
        maxWidth='sm'
        TransitionComponent={Fade}
        transitionDuration={{
          enter: 250,
        }}
      >
        <DialogTitle className='form-dialog-files__title-modal'>
          <div className='form-dialog-files__titleContainer'>
            <Typography className='form-dialog-files__titleModal'>
              {languageValues.uploadArquivos}
            </Typography>
            <IconButton
              aria-label='close'
              className='form-dialog-files__closeButton'
              onClick={handleClose}
            >
              <CloseIconModal />
            </IconButton>
          </div>
          <div className='form-dialog-files__titleLine'></div>
        </DialogTitle>
        <DialogContent>
          <Typography variant='body1' className='form-dialog-files__title'>
            {languageValues.escolhaArquivoContratoAssinado}
          </Typography>
          <Box className='form-dialog-files__box'>
            <CustomUploadSingle id={1} file={file} setFile={setFile} clearFile={handleClearFile} />
          </Box>
          <Box className='form-dialog-files__box-field'>
            <CustomSelect
              label={languageValues.tipoDeDocumento}
              placeholder={'Selecione um tipo de contrato '}
              options={finalFilteredOptions}
              onChange={handleOptionsChange}
              value={selectedOptions}
              disabled={
                getTipoEnte() === TipoContrato.ASSESSOR ||
                getTipoEnte() === TipoContrato.ENTE_PRIVADO}
            />
          </Box>
        </DialogContent>
        <DialogActions className='form-dialog-files__dialog-actions'>
          <Button
            className='form-dialog-files__btnClose'
            onClick={handleClose}
          >
            {languageValues.cancelButton}
          </Button>
          <Button
            className='form-dialog-files__btnSave'
            onClick={() => handleUpload()}
            disabled={isSaveButtonDisabled()}
          >
            {loading ? (
              <CircularProgress size={24} color='primary' />
            ) : (
              languageValues.salvar
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default React.memo(ModalFiles)
